const application = {
  // HeroSection
  'application.hero.homeLink': 'ホーム',
  'application.hero.admissionLink': '入学案内',
  'application.hero.currentPage': '応募資格・申込の流れ',
  'application.hero.imgAlt': '応募書類と万年筆を格調高く配置した静物',

  // breadcrumb
  'application.breadcrumb.home': 'ホーム',
  'application.breadcrumb.admission': '入学案内',
  'application.breadcrumb.current': '応募資格・申込の流れ',

  // Requirements
  'application.requirements.label': 'REQUIREMENTS',
  'application.requirements.title': '応募資格と申込手順は？',
  'application.requirements.titleEn': 'Eligibility & Application',
  'application.requirements.lead': '当アカデミーは、学ぶ意欲のある方に広く門戸を開いています。年齢の下限を除き、経歴や経験は問いません。執事になるには特別な前歴は不要で、日本の執事学校・日本執事アカデミーでは未経験から基礎を身につけられます。',

  // DressCode
  'application.dress.label': 'DRESS CODE',
  'application.dress.imgCaption': '白シャツ・黒スラックス・革靴・白手袋：執事の基本装い',

  // ApplicationSteps
  'application.steps.label': 'APPLICATION STEPS',
  'application.steps.title': '申込の流れ',
  'application.steps.titleEn': 'From Inquiry to Enrollment',
  'application.steps.lead': 'お申込みから受講確定までの流れを、順を追ってご説明します。各ステップで迷わないよう、ご案内を差し上げます。',
  'application.steps.optionalBadge': '任意',
  'application.steps.requiredBadge': '必須',
  'application.steps.applyLink': '申込フォームへ',

  // DeadlineInfo
  'application.deadline.label': 'DEADLINES',
  'application.deadline.contactNote': '開校日程の詳細は',
  'application.deadline.contactLink': '年間スケジュール',
  'application.deadline.contactSuffix': 'をご確認ください',

  // PaymentInfo
  'application.payment.label': 'PAYMENT',
  'application.payment.bankOnlyNote': '分割払い・クレジットカードはご利用いただけません。銀行振込による一括払いのみとなりますので、予めご了承ください。',

  // FAQSection
  'application.faq.label': 'FAQ',
  'application.faq.title': 'よくあるご質問',
  'application.faq.titleEn': 'Frequently Asked Questions',
  'application.faq.contactNote': 'その他のご質問は',
  'application.faq.contactLink': 'お問い合わせ',
  'application.faq.contactSuffix': 'よりお寄せください',

  // CTASection
  'application.cta.label': 'READY TO APPLY',
  'application.cta.title': 'ご準備が整いましたら、お申込みへ',
  'application.cta.lead': '応募資格をご確認いただき、ご不明な点がなければ、申込フォームよりお手続きください。ご不安な点がある方は、まずは個別相談をご利用ください。執事養成学校での学びを経て執事資格の取得を目指す方を、入学前から丁寧にサポートします。',
  'application.cta.onlineNote': '※ご相談はオンラインでも承ります',
  'application.cta.applyBtn': '申込フォームへ',
  'application.cta.consultBtn': '個別相談を予約する',
  'application.cta.brochureBtn': '資料請求はこちら（無料）',

  // RelatedPages
  'application.related.label': 'LEARN MORE',
  'application.related.title': '関連ページ',
  'application.related.titleEn': 'Explore Further',
  'application.related.arrowLabel': '詳しく見る',

  // footer
  'application.footer.lastUpdated': '最終更新: 2026年6月13日',
  'application.backToTop.ariaLabel': 'ページの先頭へ戻る',
};

export default application;
